module.exports = __webpack_public_path__ + "static/media/AAVE.0e2ab9ba.svg";